import { Main, Dashboard } from "components";

const Error = ({ message = "" }) => (
  <Main>
    <Dashboard header={{ title: "Błąd", icon: "info" }}>
      <div className="dashboard__body">
        <p>{message}</p>
      </div>
    </Dashboard>
  </Main>
);

export default Error;
